/**
 * Operators grouped by backend field type.
 *
 * Only operators that make semantic sense for a given type are included —
 * e.g. "Contains" and "Starts With" appear under TEXT but not under DATE
 * or NUMBER, and DATE uses human-friendly labels ("Before", "After")
 * instead of mathematical ones ("Greater Than", "Less Than").
 *
 * The `value` strings (e.g. "==", "ilike", "startswith") are the exact
 * operator tokens the backend expects in the filter payload.
 */
export const OPERATORS_BY_TYPE: Record<string, Array<{ title: string, value: string }>> = {
  DATE: [
    { title: 'Equal To', value: '==' },
    { title: 'Not Equal To', value: '!=' },
    { title: 'Before', value: '<' },
    { title: 'After', value: '>' },
    { title: 'On or Before', value: '<=' },
    { title: 'On or After', value: '>=' }
  ],
  NUMBER: [
    { title: 'Equal To', value: '==' },
    { title: 'Not Equal To', value: '!=' },
    { title: 'Greater Than', value: '>' },
    { title: 'Less Than', value: '<' },
    { title: 'Greater Than or Equal To', value: '>=' },
    { title: 'Less Than or Equal To', value: '<=' }
  ],
  TEXT: [
    { title: 'Equal To', value: '==' },
    { title: 'Not Equal To', value: '!=' },
    { title: 'Contains', value: 'contains' },
    { title: 'Does Not Contain', value: 'not_contains' },
    { title: 'Starts With', value: 'startswith' },
    { title: 'Does Not Start With', value: 'not_startswith' },
    { title: 'Ends With', value: 'endswith' },
    { title: 'Does Not End With', value: 'not_endswith' }
  ],
  BOOLEAN: [
    { title: 'Equal To', value: '==' },
    { title: 'Not Equal To', value: '!=' }
  ]
}
